function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("ellipse", {
  "data-id": "circle",
  cx: 83.5,
  cy: 26,
  rx: 11.5,
  ry: 13,
  fill: "#65dbaf",
  transform: "matrix(2.78261 0 0 2.46154 -200.348 -32)"
});

var _ref2 =
/*#__PURE__*/
React.createElement("text", {
  "data-id": "label",
  x: 299,
  y: 150.402,
  fontFamily: "Open Sans",
  fontSize: 12,
  fill: "#f1f3f8",
  textAnchor: "middle",
  transform: "translate(-775.606 -363.707) scale(2.6987)"
}, "MV");

var SvgTemplateAvatarIcon = function SvgTemplateAvatarIcon(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _ref, _ref2);
};

export default SvgTemplateAvatarIcon;